import { Grid, Typography, Box, Divider } from "@mui/material";
import { mediosMap, tarjetasMap } from "../../../../helpers/mediosPago";

const capitalize = (str = "") =>
  str.charAt(0).toUpperCase() + str.slice(1).replace(/([A-Z])/g, " $1");

/* 🟦 FUNCION ROBUSTA: Renderiza objetos, soporta anidados, vacíos y evita errores */
const renderKeyValue = (obj, parentKey = "") => {
  if (!obj || typeof obj !== "object") {
    return (
      <Grid item xs={12}>
        <Typography variant="body2">No hay datos</Typography>
      </Grid>
    );
  }

  const entries = Object.entries(obj);

  if (entries.length === 0) {
    return (
      <Grid item xs={12}>
        <Typography variant="body2">No hay datos</Typography>
      </Grid>
    );
  }

  return entries.flatMap(([key, value]) => {
    const displayKey = parentKey
      ? `${parentKey}: ${capitalize(key)}`
      : capitalize(key);

    if (value && typeof value === "object" && !Array.isArray(value)) {
      return renderKeyValue(value, displayKey);
    }

    // Mapear valores especiales
    const finalValue =
      key === "medioPago"
        ? mediosMap[value] ?? value
        : key === "Tarjeta"
          ? tarjetasMap[value] ?? value
          : value ?? "No especificado";

    return (
      <Grid item xs={6} key={displayKey + value}>
        <Typography variant="body2">
          <strong>{displayKey}:</strong> {String(finalValue)}
        </Typography>
      </Grid>
    );
  });
};const DatosPagoCliente = ({ datosCli }) => {
  // 🔒 Normalizar datosCli
  const normalized = (() => {
    if (!datosCli) return { type: 'empty', value: null };

    // Objeto directo
    if (typeof datosCli === 'object') {
      return { type: 'object', value: datosCli };
    }

    // String: intentar JSON
    if (typeof datosCli === 'string') {
      try {
        const parsed = JSON.parse(datosCli);
        if (typeof parsed === 'object') {
          return { type: 'object', value: parsed };
        }
      } catch {
        // String plano → observación
        return { type: 'text', value: datosCli };
      }
    }

    return { type: 'empty', value: null };
  })();

  // ❌ No hay nada para mostrar
  if (normalized.type === 'empty') {
    return (
      <Box sx={{ padding: 2 }}>
        <Typography variant="h6" gutterBottom>
          Datos del Pedido
        </Typography>
        <Typography>No hay datos para mostrar.</Typography>
      </Box>
    );
  }

  // 🧩 Si es objeto
  const { pago = null, obs_envio = null, mercadoPago } =
    normalized.type === 'object' ? normalized.value : {};

  const hayDatosEnvio =
    obs_envio && typeof obs_envio === 'object' && Object.keys(obs_envio).length > 0;

  const hayDatosPago =
    (pago && typeof pago === 'object' && Object.keys(pago).length > 0) ||
    mercadoPago !== undefined;

  return (
    <Box sx={{ padding: 2 }}>

      {/* 🟩 DATOS DE ENVÍO */}
      {hayDatosEnvio && (
        <>
          <Typography variant="h6" gutterBottom>
            Datos de Envío
          </Typography>
          <Grid container spacing={2}>
            {renderKeyValue(obs_envio)}
          </Grid>
        </>
      )}

      {/* 🟦 OBSERVACIÓN (string plano) */}
      {normalized.type === 'text' && (
        <>
          <Divider sx={{ my: 3 }} />
          <Typography variant="h6" gutterBottom>
            Observación
          </Typography>
          <Typography sx={{ whiteSpace: 'pre-line' }}>
            {normalized.value}
          </Typography>
        </>
      )}

      {/* 🟦 DATOS DE PAGO */}
      {hayDatosPago && (
        <>
          <Divider sx={{ my: 3 }} />
          <Typography variant="h6" gutterBottom>
            Datos de Pago
          </Typography>
          <Grid container spacing={2}>
            {pago ? (
              renderKeyValue(pago)
            ) : (
              <Grid item xs={12}>
                <Typography>No hay datos de pago disponibles.</Typography>
              </Grid>
            )}
          </Grid>
        </>
      )}

      {/* 🟨 Fallback visual */}
      {!hayDatosEnvio && !hayDatosPago && normalized.type !== 'text' && (
        <Typography>No hay datos para mostrar.</Typography>
      )}
    </Box>
  );
};


export default DatosPagoCliente;
